import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IDrawsState, IGetDrawsStat } from ".";
import { IDraw } from "../../pages/DrawPage/DrawItem";

export interface IGetDrawsResponse {
    draws: IDraw[],
    stat: IGetDrawsStat;
    fragments: number;
    fragmentsPrizes: number;
};

export const getDraws = createAsyncThunk<IGetDrawsResponse>(
    'draws/getDraws',
    async () => await api.draws.getDraws()
);

const getDrawsHandler = (builder: ActionReducerMapBuilder<IDrawsState>) => {
    builder
        .addCase(getDraws.pending, (state: IDrawsState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getDraws.fulfilled, (state: IDrawsState, action: PayloadAction<IGetDrawsResponse>) => {
            state.loading = false;

            if (!action.payload)
                return;

            state.items = action.payload.draws.sort((a, b) => a.operDate - b.operDate) ?? [];
            state.stat = action.payload.stat;
            state.fragments = action.payload.fragments;
            state.fragmentsPrizes = action.payload.fragmentsPrizes;
        })
        .addCase(getDraws.rejected, (state: IDrawsState) => {
            state.loading = false;
            state.error = 'Unable to get draws';
        });
};

export default getDrawsHandler;